let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aBa7j")).then(() => parcelRequire('76Zjl'));